import theme from "@theme/index";

export enum CancelRequestStatus {
  Pending = "pending",
  Declined = "declined",
}

export const CancelQuestColor = {
  color: {
    [CancelRequestStatus.Pending]: theme.palette.common.mediumText,
    [CancelRequestStatus.Declined]: theme.palette.common.black,
  },
  bgColor: {
    [CancelRequestStatus.Pending]: theme.palette.common.mediumPriorty,
    [CancelRequestStatus.Declined]: theme.palette.common.bellflowerBlue,
  },
} as const;
